import {zipcodes} from './zipcodes'

export const replaceAt = (arr, idx, repl) => {
  let copy = arr instanceof Array ? arr.slice() : [];
  copy[idx] = repl
  return copy;
}

export const zip = {getState: state => zipcodes[state]}



// WEBPACK FOOTER //
// ./src/utils/index.js